import { render, staticRenderFns } from "./LabelInfo.vue?vue&type=template&id=aa70eda8&"
import script from "./LabelInfo.vue?vue&type=script&lang=js&"
export * from "./LabelInfo.vue?vue&type=script&lang=js&"
import style0 from "./Styles.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./LabelInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports